import React from "react";
import { useTranslation } from "react-i18next";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "../../Question";
import { MultipleChoiceQuestion } from "../core";

const QUESTION_ID = "motivation";

declare module "@/contexts" {
  interface SurveyAnswers {
    motivation?: string;
  }
}

const MotivationQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    {
      id: "healthCareProfessional",
      text: t("motivation.options.healthCareProfessional"),
    },
    { id: "bloodTestResults", text: t("motivation.options.bloodTestResults") },
    { id: "wellnessPlan", text: t("motivation.options.wellnessPlan") },
    {
      id: "healthInsurancePlan",
      text: t("motivation.options.healthInsurancePlan"),
    },
    { id: "noomAd", text: t("motivation.options.noomAd") },
    { id: "familyOrFriend", text: t("motivation.options.familyOrFriend") },
    { id: "knowsNoomUser", text: t("motivation.options.knowsNoomUser") },
    { id: "community", text: t("motivation.options.community") },
    {
      id: "healthRiskAssessment",
      text: t("motivation.options.healthRiskAssessment"),
    },
    { id: "programChampion", text: t("motivation.options.programChampion") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("motivation.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_MOTIVATION: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: MotivationQuestion,
};

export const Q_RETRIAGE_MOTIVATION: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: MotivationQuestion,
};
